<template>
  <v-badge
    bordered
    :color="notificationsLength ? 'green darken-5' : 'grey lighten-2'"
    :content="notificationsLength > 100 ? '100+' : notificationsLength"
    :value="notificationsLength"
    overlap
    top
    right
  >
    <slot />
  </v-badge>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'NotificationBadge',

  props: {
    notificationsLength: {
      type: Number,
      default: 0
    }
  }
})
</script>
